import React from 'react';
import { Text, Title, TitleProps } from '@soluto-design/react';
import cls from '@soluto-design/styles/cls';

export interface BlockTitleTextProps {
    title?: string;
    titleTag?: TitleProps['component'];
    text?: string;
}

const BlockTitleText = ({ title, titleTag, text }: BlockTitleTextProps) => {
    return (
        <div className="row mb-xl gap-y-24">
            {title && (
                <Title
                    isHtml
                    className={cls(
                        'col-span-full text-h300 text-text-primary',
                        text && 'lg:col-span-4 xl:col-span-6',
                    )}
                    component={titleTag}>
                    {title}
                </Title>
            )}
            {text && (
                <div
                    className={cls(
                        'col-span-full text-b600 text-text-secondary flex flex-col gap-24 lg:col-span-4 xl:col-span-6',
                        !title && 'lg:col-span-4 xl:col-span-6',
                    )}>
                    {text && (
                        <Text
                            isHtml
                            component="div"
                            className="text-b300 text-text-secondary">
                            {text}
                        </Text>
                    )}
                </div>
            )}
        </div>
    );
};

export default BlockTitleText;
